import Rails from '@rails/ujs'
Rails.start()

import '@hotwired/turbo-rails'

import '../controllers'
